import React, { useState, useEffect } from 'react';
import { css } from '@emotion/css';

type LiveFeedbackProps = {
  message: string;
  ariaLive?: 'polite' | 'assertive';
};

export const LiveFeedback: React.FC<LiveFeedbackProps> = ({ message, ariaLive = 'polite' }) => {
  return (
    <div aria-live={ariaLive} aria-atomic="true" className="visually-hidden">
      {message}
    </div>
  );
};
